export const identityList = [{
		value: '企业从业人员',
		text: '企业从业人员',
		children: [{
				value: '主要负责人',
				text: '主要负责人',
			},
			{
				value: '分管负责人',
				text: '分管负责人',
			},
			{
				value: '安全总监',
				text: '安全总监',
			},
			{
				value: '部门负责人（安全）',
				text: '部门负责人（安全）',
			},
			{
				value: '部门负责人（其他）',
				text: '部门负责人（其他）',
			},
			{
				value: '安全管理人员',
				text: '安全管理人员',
			},
			{
				value: '生产技术管理人员',
				text: '生产技术管理人员',
			},
			{
				value: '设备工程管理人员',
				text: '设备工程管理人员',
			},
			{
				value: '电气仪表管理人员',
				text: '电气仪表管理人员',
			},
			{
				value: '其他管理人员',
				text: '其他管理人员',
			},
			{
				value: '工艺操作人员',
				text: '工艺操作人员',
			},
			{
				value: '电气仪表操作人员',
				text: '电气仪表操作人员',
			},
			{
				value: '企业其他人员',
				text: '企业其他人员',
			},
			{
				value: '劳务派遣人员',
				text: '劳务派遣人员',
			},
			{
				value: '灵活用工人员',
				text: '灵活用工人员',
			},
		],
	},
	{
		value: '进入企业生产厂区的外来人员',
		text: '进入企业生产厂区的外来人员',
		children: [{
				value: '承包商人员',
				text: '承包商人员',
			},
			{
				value: '实习人员',
				text: '实习人员',
			},
			{
				value: '其他外来施工人员',
				text: '其他外来施工人员',
			},
		],
	},
]